module.exports = __webpack_public_path__ + "static/media/02.8f512a98.jpg";